var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 85,
    rx: 42.5,
    fill: "#FFF6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 48.25H44.75V51.75H41.25V48.25ZM41.25 34.25H44.75V44.75H41.25V34.25ZM43 25.5C33.3225 25.5 25.5 33.375 25.5 43C25.5 47.6413 27.3437 52.0925 30.6256 55.3744C32.2507 56.9994 34.1798 58.2884 36.303 59.1679C38.4262 60.0474 40.7019 60.5 43 60.5C47.6413 60.5 52.0925 58.6563 55.3744 55.3744C58.6563 52.0925 60.5 47.6413 60.5 43C60.5 40.7019 60.0474 38.4262 59.1679 36.303C58.2884 34.1798 56.9994 32.2507 55.3744 30.6256C53.7493 29.0006 51.8202 27.7116 49.697 26.8321C47.5738 25.9527 45.2981 25.5 43 25.5ZM43 57C39.287 57 35.726 55.525 33.1005 52.8995C30.475 50.274 29 46.713 29 43C29 39.287 30.475 35.726 33.1005 33.1005C35.726 30.475 39.287 29 43 29C46.713 29 50.274 30.475 52.8995 33.1005C55.525 35.726 57 39.287 57 43C57 46.713 55.525 50.274 52.8995 52.8995C50.274 55.525 46.713 57 43 57Z",
    fill: "#ED9500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.5db878edcf45cf443c2b27f3d38ecb91.svg";
export { ForwardRef as ReactComponent };